import { render, staticRenderFns } from "./SummaryView.vue?vue&type=template&id=d548550e&scoped=true"
import script from "./SummaryView.vue?vue&type=script&lang=js"
export * from "./SummaryView.vue?vue&type=script&lang=js"
import style0 from "./SummaryView.vue?vue&type=style&index=0&id=d548550e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d548550e",
  null
  
)

export default component.exports